import { useGameContainer } from '../index';
import GamePickEm from './GamePickEm';
import GameScoringSummary from './GameScoringSummary';
import GameQuarterByQuarter from './GameQuarterByQuarter';
import GameLeaders from './GameLeaders';
import GameOverview from './GameOverview';
import GameLatestNews from './GameLatestNews';
import GameStandings from './GameStandings';
import GameWatchLive from './GameWatchLive';
import GamePhotos from './GamePhotos';
import GameResults from './GameResults';
import GameTeamComparison from './GameTeamComparison';
import GameFindTickets from './GameFindTickets';
import GamePrediction from './GamePrediction';
import ScreenSizes, { ScreenSize } from '@/components/ScreenSizes';
import PageLayout, { PageLayoutModule } from '@/components/PageLayout';
import ContentSection from '@/components/ContentSection';
import Page from '@/components/Page';
import GameSubNav from '@/components/subNavs/GameSubNav';
import StnVideoAd from '@/components/ads/StnVideoAd';
import MinuteMediaAd from '@/components/ads/MinuteMediaAd';
import useScreenSize from 'hooks/useScreenSize';
import Sponsor, { RIGHT } from 'components/Sponsor';
import OutbrainAd from '@/components/ads/OutbrainAd';
import GameSeries from './GameSeries';
import GameSeriesHeader from './GameSeriesHeader';

export default function GameDetails() {
  const [{ game }] = useGameContainer();
  const { isSmallScreen } = useScreenSize();

  return (
    <Page
      subNav={
        <>
          <GameSeriesHeader />
          <GameSubNav game={game} />
        </>
      }
    >
      <PageLayout
        sidebar={
          <>
            <PageLayoutModule order={10}>
              <GameWatchLive />
            </PageLayoutModule>
            <PageLayoutModule order={20}>
              <GameFindTickets />
            </PageLayoutModule>
            <PageLayoutModule order={41}>
              <GameSeries />
            </PageLayoutModule>
            <PageLayoutModule order={51}>
              <MinuteMediaAd placement={isSmallScreen ? 'IN_FEED' : 'SIDEBAR'} />
            </PageLayoutModule>
            <PageLayoutModule order={80}>
              <GameOverview />
            </PageLayoutModule>
            <PageLayoutModule order={100}>
              <GameStandings />
            </PageLayoutModule>
            <PageLayoutModule order={101}>
              <MinuteMediaAd placement={isSmallScreen ? 'IN_FEED_2' : 'SIDEBAR_2'} />
            </PageLayoutModule>
            <PageLayoutModule order={120}>
              <ContentSection>
                <MinuteMediaAd placement={isSmallScreen ? 'IN_FEED_2' : 'SIDEBAR_2'} />
              </ContentSection>
            </PageLayoutModule>
          </>
        }
      >
        <PageLayoutModule order={30}>
          <GameQuarterByQuarter />
        </PageLayoutModule>
        <ScreenSizes hide={ScreenSize.SMALL}>
          <GameScoringSummary />
        </ScreenSizes>
        <PageLayoutModule order={40}>
          <GamePickEm />
        </PageLayoutModule>
        <PageLayoutModule order={41}>
          <GamePrediction />
        </PageLayoutModule>
        <PageLayoutModule order={50}>
          <GamePhotos />
        </PageLayoutModule>
        <PageLayoutModule>
          <StnVideoAd placement="INLINE" />
        </PageLayoutModule>
        <PageLayoutModule order={60}>
          <GameResults />
        </PageLayoutModule>
        <PageLayoutModule order={90}>
          <GameLeaders />
        </PageLayoutModule>
        <PageLayoutModule order={70}>
          <GameTeamComparison />
        </PageLayoutModule>
        <PageLayoutModule order={110}>
          <GameLatestNews />
        </PageLayoutModule>
        <PageLayoutModule order={130}>
          <OutbrainAd />
        </PageLayoutModule>
      </PageLayout>
    </Page>
  );
}
